__turbopack_context__.v({
  "theme-switcher": "ThemeSwitcher-module__b37ZMW__theme-switcher",
});
